import React from 'react'

function Footer() {

    return (
        <footer>
            <a href="https://github.com/Kraft-Dinner/itsme" target="_blank" rel="noreferrer" >
                Designed and built by Kristen Dergousoff
            </a>
        </footer>
    );
}

export default Footer;